<template>
  <div v-if="user" class="min-h-screen bg-gray-100">
    <SidebarMenu :user="user" :isMenuOpen="isMenuOpen" @toggle-menu="toggleMenu" @close-menu="closeMenu"
      @logout="logout" />

    <div class="md:ml-64">
      <main class="p-4">
        <div class="p-4">
          <h1 class="text-xl font-bold mb-6">Agregar Seguimiento al prospecto #{{ prospectId }}</h1>

          <div v-if="loading" class="flex justify-center my-8">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>

          <div>
            <form @submit.prevent="saveFollowUp" class="mt-6">
              <!-- Información del seguimiento -->
              <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white p-6 mb-6">
                <h2 class="text-lg font-semibold mb-4">Información del Seguimiento</h2>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <!-- Información del prospecto (solo para referencia) -->
                  <div class="hidden">
                    <label class="block text-sm font-medium text-gray-500">ID del Prospecto</label>
                    <input type="text" :value="prospectId" disabled
                      class="mt-1 block w-full rounded-md border-gray-300 bg-gray-100 shadow-sm" />
                  </div>

                  <!-- Tipo de contacto -->
                  <div class="md:col-span-2">
                    <label for="contactType" class="block text-sm font-medium text-gray-500">Tipo de Contacto*</label>
                    <select id="contactType" v-model="formData.ContactTypeId" required
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
                      <option value="">Seleccionar Tipo de Contacto</option>
                      <option v-for="contactType in contactTypes" :key="contactType.ContactTypeId"
                        :value="contactType.ContactTypeId">
                        {{ contactType.ContactType }}
                      </option>
                    </select>
                  </div>

                  <!-- Comentarios - Campo de texto grande -->
                  <div class="md:col-span-2">
                    <label for="comments" class="block text-sm font-medium text-gray-500">Comentarios*</label>
                    <textarea id="comments" v-model="formData.Comments" rows="4" required
                      placeholder="Ingrese información detallada sobre el seguimiento"
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"></textarea>
                  </div>
                </div>
              </div>

              <!-- Botones de acción -->
              <div class="flex flex-col sm:flex-row gap-3 justify-end mt-6">
                <button type="button"
                  class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  @click="goBack">
                  <svg class="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" stroke-width="2"
                    viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Cancelar
                </button>
                <button type="submit"
                  class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  :disabled="loading">
                  <svg v-if="!loading" class="w-4 h-4 mr-2 text-white" fill="none" stroke="currentColor"
                    stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7" />
                  </svg>
                  {{ loading ? 'Guardando...' : 'Guardar Seguimiento' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SidebarMenu from '@/components/SidebarMenu.vue';
import { getContactTypes, createProspectActivity } from '@/services/api.js';

export default {
  components: {
    SidebarMenu
  },
  data() {
    return {
      user: null,
      isMenuOpen: false,
      loading: false,
      errorMessage: null,
      contactTypes: [],
      prospectId: null,
      formData: {
        ProspectId: null,
        ContactTypeId: '',
        Comments: '',
        UserName: ''
      }
    };
  },
  async created() {
    // Capturar el ID del prospecto de la ruta
    this.prospectId = parseInt(this.$route.params.prospectId);

    await this.getUserFromBackend();
    if (this.user) {
      // Extraer el username del email del usuario (si existe)
      if (this.user.email && this.user.email.match(/^a(\d+)@/)) {
        this.formData.UserName = this.user.email.match(/^a(\d+)@/)[1];
      }

      // Cargar los tipos de contacto
      await this.loadContactTypes();

      // Asignar el ID del prospecto al formulario
      this.formData.ProspectId = this.prospectId;
    }
  },
  methods: {
    async getUserFromBackend() {
      try {
        const response = await axios.get('/me');
        this.user = response.data.user;
      } catch (error) {
        console.error("Error obteniendo usuario", error);
        this.$router.push('/login');
      }
    },
    async loadContactTypes() {
      try {
        this.loading = true;
        const response = await getContactTypes();
        this.contactTypes = response.data || [];
      } catch (error) {
        console.error('Error al cargar tipos de contacto:', error);
        this.loading = false;
        await this.$alert(
            'Error',
            'No se pudieron cargar los tipos de contacto.',
            'error'
        );

      } finally {
        this.loading = false;
      }
    },
    async saveFollowUp() {
      try {
        this.loading = true;

        // Validar que todos los campos requeridos estén completos
        if (!this.formData.ContactTypeId || !this.formData.Comments) {
          throw new Error('Por favor complete todos los campos requeridos');
        }

        // Asegurarse de que el ID del prospecto esté actualizado en el payload
        this.formData.ProspectId = this.prospectId;

        console.log('Enviando datos:', this.formData); // Para depuración

        // Realizar la petición para guardar el seguimiento usando la función del api.js
        const response = await createProspectActivity(this.formData);
        console.log(response);

        this.loading = false;
        await this.$alert(
            'Seguimiento registrado exitosamente',
            '',
            'success'
          );

        // Limpiar el formulario después de guardar exitosamente
        this.formData.ContactTypeId = '';
        this.formData.Comments = '';

      } catch (error) {
        console.error('Error al guardar seguimiento:', error);

        this.loading = false;
        await this.$alert(
            'Error al registrar el seguimiento',
            'Por favor, intente nuevamente.',
            'error'
        );
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.go(-1); // Volver a la página anterior
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    async logout() {
      try {
        // Obtener nuevo token CSRF
        await axios.get('/sanctum/csrf-cookie');

        // Esperar un momento para asegurar que la cookie se haya establecido
        await new Promise(resolve => setTimeout(resolve, 100));

        // Realizar la petición de logout
        const response = await axios.post('/logout', {}, {
          withCredentials: true,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });
        console.log(response);
        // Limpiar cookies locales
        document.cookie.split(";").forEach(function (c) {
          document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });

        // Redirigir al login
        this.$router.push('/login');
      } catch (error) {
        console.error('Error al cerrar sesión:', error.response?.data || error);
      }
    }
  }
};
</script>